import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject, take } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class MessagingService {
  private ngUnsubscribe = new Subject();
  currentMessage = new BehaviorSubject(null);

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private db: AngularFireDatabase,
    private toastr: ToastrService,
    private afAuth: AngularFireAuth
  ) {}

  private updateToken(token) {
    console.log('update token')
    this.afAuth.authState.pipe(take(1)).subscribe((user) => {
      if (!user) return;
      const data = { [user.uid]: token };
      this.db.object('fcmTokens/').update(data);
    });
  }
  token:any;
  getPermission() {
    this.angularFireMessaging.requestPermission
      .pipe(take(1))
      .subscribe((x) => {
        console.log(x,'data')
        this.angularFireMessaging.getToken.pipe(take(1)).subscribe((token) => {
          this.updateToken(token);
          this.token=token
        });
      });
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((payload) => {
      console.log(payload, 'payload');
      this.currentMessage.next(payload);
    });
  }
  getToken(){
    return this.token
    }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }
}
